<div
  class="relative mx-auto block w-full md:max-w-lg rounded-lg bg-white px-8 lg:px-14 py-8 lg:py-14 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]">

  <button (click)="drawerService.close()"
          class="absolute top-1 right-1 inline-flex rounded-md p-1.5 text-gray-500 hover:text-bleuCaliceo-300 focus:outline-none focus:ring-1 focus:ring-bleuCaliceo-300 focus:ring-offset-2 focus:ring-offset-bleuCaliceo-100"
          type="button">
    <span class="sr-only">Dismiss</span>
    <svg aria-hidden="true" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
    </svg>
  </button>
  <!--Center title -->
  <h1 class="font-bold text-2xl md:text-3xl leading-tight text-bleuCaliceo-300 uppercase text-center">
    {{ 'confirmDeleteAccount' | translate }}
  </h1>
  <!-- Description -->
  <p [innerHtml]="'confirmDeleteAccountDescription' | translate | byPass"
     class="my-4 text-gray-500 font-semibold text-start whitespace-pre-line">
  </p>

  @for (item of outstanding(); track $index) {
    <div class="my-4 rounded-md bg-bleuCaliceo-100 p-4 text-start text-gray-700">
      <p class="font-bold">{{ 'deleteAccountOutstanding.' + item.type + '.title' | translate: { label: item.label } }}</p>
      <p>
        {{ 'deleteAccountOutstanding.' + item.type + '.description' | translate: {
          label: item.label,
          remaining: item.type === 'timeCredit' ? duration(item.remaining ?? 0) : (item.remaining ?? 0).toString(),
          expiresAt: item.expiresAt ? (item.expiresAt | date: 'dd/MM/yyyy') : ''
        } }}
      </p>
    </div>
  }
  @if (outstanding().length) {
    <p class="my-4 text-gray-500 font-semibold text-start whitespace-pre-line">
      {{ 'deleteAccountOutstandingWarning' | translate }}
    </p>
  }

  <div class="mt-8 flex flex-col md:flex-row gap-4">
    <button (click)="drawerService.close()" class="grow main-btn bg-gray-400 hover:bg-gray-300">
      {{ 'cancel' | translate }}
    </button>
    <button [appProgressClick]="requestDeletion"
            [disabled]="!loaded()"
            class="grow main-btn">
      {{ 'delete' | translate }}
    </button>
  </div>
</div>
